import { getEnv } from 'common-nextjs';

interface GuessedPaypalEvent {
  event: string;
  identified?: boolean;
}

export default function firePaypalEvent(event: GuessedPaypalEvent) {
  if (getEnv() !== 'production') {
    console.groupCollapsed('Paypal Event');
    console.log(event);
    console.groupEnd();
  }

  window.paypalDDL = window.paypalDDL || [];
  window.paypalDDL.push(event);
}
